import { Component, OnInit } from '@angular/core';
import { ConductListTableConfig } from '../conduct-list.table-config';
import { ConductService } from '@app/services';

@Component({
  selector: 'app-conduct-dashboard-report',
  templateUrl: './conduct-dashboard-report.component.html',
  styleUrls: ['./conduct-dashboard-report.component.scss']
})
export class ConductDashboardReportComponent implements OnInit {

  config: any;

  conductList: any[];
  activeConductList: any[] = [];
  completedConductList: any[] = [];

  activePieChartData: any;
  completedPieChartData: any;

  constructor(
    private conductService: ConductService
  ) { }

  ngOnInit(): void {
    this.config = ConductListTableConfig.configure();

    this.getList();
  }

  getList() {
    this.conductService.list(null, null, true).subscribe({
      next: (res: any) => {
        this.conductList = res.data;
        this.activeConductList = []
        this.completedConductList = []
        for (let conduct of this.conductList) {
          conduct.clientName = `${conduct?.client?.user?.firstName ?? ''} ${conduct?.client?.user?.lastName ?? ''}`
          conduct.brokerName = `${conduct?.broker?.user?.firstName ?? ''} ${conduct?.broker?.user?.lastName ?? ''}`
          if (conduct.locked == true) {
            this.completedConductList.push(conduct)
          } else {
            this.activeConductList.push(conduct)
          }
        }

        this.activePieChartData = []
        this.completedPieChartData = []

        let surveyHash: any = {}

        for (let conduct of this.conductList) {
          if (!surveyHash[conduct.survey?._id]) {
            surveyHash[conduct.survey?._id] = {
              name: conduct.survey?.name,
              completed: 0,
              active: 0
            }
          }
          surveyHash[conduct.survey?._id][conduct.locked == true ? 'completed' : 'active'] += 1
        }

        for (let surveyId in surveyHash) {
          if (surveyHash[surveyId].active > 0) {
            this.activePieChartData.push({
              name: surveyHash[surveyId].name,
              count: surveyHash[surveyId].active
            })
          }

          if (surveyHash[surveyId].completed > 0) {
            this.completedPieChartData.push({
              name: surveyHash[surveyId].name,
              count: surveyHash[surveyId].completed
            })
          }
        }

        console.log(surveyHash)
        console.log(this.activePieChartData, this.completedPieChartData)
      },
      error: console.log
    })
  }

}
